import React from 'react';
import Styled from './ProductTagsStyled';
import { Tag } from '@grupoboticario/flora-react';
import { IProduct } from 'src/common/types/CatalogType';

interface IProductTags extends Pick<IProduct, 'tags'> {} //NOSONAR

interface TagItem {
  tag: string;
}

const ProductTagItem = ({ tag }: TagItem): JSX.Element => {
  if (tag.startsWith('-')) {
    return (
      <Tag data-testid={tag} size="small">
        {tag}
      </Tag>
    );
  }
  return (
    <Tag
      data-testid={tag}
      shape="ghost"
      size="small"
      css={{ marginLeft: '$2' }}
    >
      {tag}
    </Tag>
  );
};

const ProductTags = ({ tags }: IProductTags): JSX.Element => {
  return (
    <Styled.TagContainer>
      {tags &&
        tags.map((item: string, index: number) => (
          <ProductTagItem key={index} tag={item} />
        ))}
    </Styled.TagContainer>
  );
};

export default ProductTags;
